import type { MeResponse } from '../../entities/me/me-contract.types';

export type StaffBootstrapState =
  | { kind: 'loading' }
  | { kind: 'anonymous' }
  | { kind: 'authenticated_without_org_context' }
  | { kind: 'authenticated_with_org_context' }
  | { kind: 'impersonating_org'; organizationId: number }
  | { kind: 'forbidden'; reason?: string }
  | { kind: 'module_unavailable'; moduleCode?: string; detail?: string }
  | { kind: 'bootstrap_error'; message: string };

/** Ошибка загрузки `me` после ответа HTTP (403 и т.д.). */
export type MeHttpBlocker =
  | { kind: 'forbidden'; message?: string }
  | { kind: 'module_unavailable'; moduleCode?: string; message?: string };

export type ResolveStaffBootstrapInput = {
  tokenPresent: boolean;
  me: MeResponse | null;
  impersonateOrganizationId: number | null;
  fetchError: string | null;
  meHttpBlocker: MeHttpBlocker | null;
};

export function resolveStaffBootstrapState(input: ResolveStaffBootstrapInput): StaffBootstrapState {
  const { tokenPresent, me, impersonateOrganizationId, fetchError, meHttpBlocker } = input;

  if (fetchError) return { kind: 'bootstrap_error', message: fetchError };

  if (meHttpBlocker?.kind === 'module_unavailable') {
    return {
      kind: 'module_unavailable',
      moduleCode: meHttpBlocker.moduleCode,
      detail: meHttpBlocker.message
    };
  }
  if (meHttpBlocker?.kind === 'forbidden') {
    return { kind: 'forbidden', reason: meHttpBlocker.message ?? 'forbidden' };
  }

  if (tokenPresent && me == null) {
    return { kind: 'loading' };
  }
  if (!tokenPresent || me == null) return { kind: 'anonymous' };

  const shell = me.capabilities?.staff_admin_shell;
  if (shell && shell.allowed === false) {
    return { kind: 'forbidden', reason: 'staff_admin_shell' };
  }

  if (impersonateOrganizationId != null && impersonateOrganizationId > 0) {
    return { kind: 'impersonating_org', organizationId: impersonateOrganizationId };
  }

  const orgId = me.organization_id;
  if (orgId == null || orgId <= 0) return { kind: 'authenticated_without_org_context' };

  return { kind: 'authenticated_with_org_context' };
}

export function isReadyState(s: StaffBootstrapState): boolean {
  return (
    s.kind === 'authenticated_without_org_context' ||
    s.kind === 'authenticated_with_org_context' ||
    s.kind === 'impersonating_org'
  );
}

export function isBlockingState(s: StaffBootstrapState): boolean {
  return s.kind === 'forbidden' || s.kind === 'module_unavailable' || s.kind === 'bootstrap_error';
}
